export enum PlatformIdEnum {
    STORK = 1,
    SAAS = 2,
    FLASH = 3,
}
